/* eslint-disable prefer-const */
/* eslint-disable arrow-body-style */
const sessionSet = (key, val) => {
    sessionStorage.setItem(key, JSON.stringify({ data: val }));
};

const sessionGet = (key) => {
    let val = sessionStorage.getItem(key);
    let parse = JSON.parse(val);
    return parse ? parse.data : undefined;
};

const storageSet = (key, val) => {
    let startTime = new Date().getTime();
    localStorage.setItem(key, JSON.stringify({ data: val, st: startTime }));
};

const storageGet = (key) => {
    let val = localStorage.getItem(key);
    let parse = JSON.parse(val);
    return parse ? parse.data : undefined;
};

const storageGetByTime = (key, exp) => {
    let val = localStorage.getItem(key);
    let parse = JSON.parse(val);
    if (parse) {
        if ((new Date().getTime() - parse.st) >= exp * 24 * 60 * 60 * 1000) {
            console.log('信息已过期');
            return undefined;
        }
        return parse.data || undefined;
    }
    return undefined;
};

export default {
    sessionSet,
    sessionGet,
    storageSet,
    storageGet,
    storageGetByTime
};



// WEBPACK FOOTER //
// ./src/util/shareData/index.js